import styled from "@emotion/styled/macro";

export const ModalHeaderContainer = styled.div`
  padding: 22.5px 24px;
  display: flex;
  align-items: center;
  gap: 15px;
  background-color: #FFFFFF;
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
  box-shadow: inset 0px -1px 0px 0px #DDE3EB;
  position: relative;
`;

export const ModalTitle = styled.h3`
  margin: 0;
  font-size: 16px;
  font-weight: 500;
  color: #1A1B1D;
  font-family: Circular;
  line-height: 1.2649999856948853em;
`;

export const CloseIconContainer = styled.div`
  cursor: pointer;
  position: absolute;
  right: 24px;
  top: 22px;
  width: 16px;
  height: 16px;
`;

export const ModalContentContainer = styled.div`
  padding: 30px 68px;
  overflow: auto;
  flex: 1;
`;

export const ModalFooterContainer = styled.div`
  padding: 13px 0px;
  border-top: 1px solid #DDE3EB;
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  background-color: #FFFFFF;
  border-bottom-left-radius: 12px;
  border-bottom-right-radius: 12px;
  box-shadow: inset 0px 1px 0px 0px #E7E8EA;
`;

export const ActionButtonStyled = styled.button`
  padding: 8px 20px;
  background-color: ${props => props.backgroundColor || '#1A1B1D'};
  color: ${props => props.whiteText ? '#FFFFFF' : '#1A1B1D'};
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.193359375em;
  box-shadow: 0px 0px 2px 0px rgba(0, 0, 0, 0.16), 0px 2px 4px 0px rgba(0, 0, 0, 0.04);
  margin-right: 24px;
  height: 38px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
`;

export const WarningMessage = styled.div`
  margin-top: 16px;
  padding: 12px;
  background-color: #F1F3F5;
  border-radius: 6px;
  font-size: 14px;
  color: #777D87;
`; 